// extracted by mini-css-extract-plugin
export default {"container":"Qz-z","dimension":"Rz-z","dimensionLabels":"Sz-z"};